import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import i18next from "src/i18n/config";
import authService from "src/services/authService";
import { toAppUrl } from "src/services/configService";
import ElasticService from "src/services/elasticService";

import { PageContainer } from "@dashboard/shared/components/PageContainer";
import { Typography } from "@mui/material";
import { withMetaDescription } from "@navigation/utils/withMetaDescription";

const LogoutPage = () => {
    const { t } = useTranslation("pages");

    useEffect(() => {
        const logout = async () => {
            await authService.logout();
            ElasticService.updateUserContext();
            window.location.href = toAppUrl("/login");
        };
        void logout();
    }, []);

    return (
        <PageContainer fullWidth={false}>
            <Typography style={{ textAlign: "center" }} variant="h4">
                {t("logoutPage.title")}
            </Typography>
        </PageContainer>
    );
};

export default withMetaDescription(LogoutPage, {
    title: i18next.t("pages:logoutPage.metaTitle"),
    description: i18next.t("pages:logoutPage.metaDescription"),
});
